// A video's "Remove background" in the Parameters, just above Chroma Key (spec
// remove-background.md): its run's state, from `use-remove-background.ts`, and Restore original.
import { Button, Progress, Text } from "@mantine/core";
import { Eraser, Undo2 } from "lucide-react";

import { ParamSection } from "./params";
import type { BackgroundRun } from "./use-remove-background";
import type { VideoClip } from "./timeline";
import classes from "./editor.module.css";

export function BackgroundSection(props: {
  clip: VideoClip;
  run: BackgroundRun | null;
  onRemove: () => void;
  onRestore: () => void;
}) {
  const { clip, run, onRemove, onRestore } = props;
  if (run?.state === "starting" || run?.state === "running") {
    // A job tells no share done: the bar moves while it runs.
    return (
      <ParamSection title="Remove background">
        <Text className={classes.paramNote}>Removing background…</Text>
        <Progress size={4} value={100} animated aria-label="Removing background" />
      </ParamSection>
    );
  }
  if (run?.state === "failed") {
    return (
      <ParamSection title="Remove background">
        <Text className={classes.paramNote} role="alert">
          The background could not be removed.
        </Text>
        <Text className={classes.paramNote}>{run.reason}</Text>
        <Button className={classes.paramButton} size="xs" variant="default" onClick={onRemove}>
          Try again
        </Button>
      </ParamSection>
    );
  }
  if (clip.originalSource !== null) {
    return (
      <ParamSection title="Remove background">
        <Text className={classes.paramNote}>Background removed</Text>
        <Button
          className={classes.paramButton}
          size="xs"
          variant="default"
          leftSection={<Undo2 size={13} aria-hidden />}
          onClick={onRestore}
        >
          Restore original
        </Button>
      </ParamSection>
    );
  }
  return (
    <ParamSection title="Remove background">
      <Button
        className={classes.paramButton}
        size="xs"
        variant="default"
        leftSection={<Eraser size={13} aria-hidden />}
        onClick={onRemove}
      >
        Remove background
      </Button>
      <Text className={classes.paramNote}>Free. Studio&apos;s Edit Background.</Text>
    </ParamSection>
  );
}
